export default __webpack_public_path__ + "static/media/1930.d9e39055.png";